import { Link } from "@material-ui/core";
import { enhancer as buttonEnhancer } from "./Button";

const enhancer = buttonEnhancer;

export default enhancer(Link);
